import React from 'react';

import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { push } from 'react-router-redux';
import { Drawer } from 'rsuite';

import OrganizationMenu from '@src/components/Header/OrganizationMenu';
import styles from '@src/components/Header/SidebarMenu.module.less';

import APP_ROUTES from '@src/app_routes';
import { FeatureRenderer } from '@src/hoc/FeatureRenderer';
import { FEATURES, PLANS } from '@src/plans-permissions';
import getMenuByUserRoleAndFeatureAccess from '@src/redux/data/menu';
import {
  getFeaturePermissions,
  getUserName,
  logout,
} from '@src/redux/modules/auth';
import { getIsSidebarMenuShowing, hideSidebarMenu } from '@src/redux/modules/header';
import SidebarMenuItem from '@src/components/Header/SidebarMenuItem';

function handleUpgradeButtonClick(_push) {
  ReactGA.event({
    category: 'Header',
    action: 'Header upgrade link',
  });

  _push(APP_ROUTES.billing);
}

const SidebarMenu = ({
  _hideSidebarMenu,
  _logOut,
  _push,
  shouldShowSidebarMenu,
  userName,
  user,
  featurePermissions,
}) => {
  const isAdminUser = user?.role === 1;

  const { tabMenuItems } = getMenuByUserRoleAndFeatureAccess(
    isAdminUser,
    featurePermissions
  );

  const isMultiuserEnabled = Number(featurePermissions?.MULTIUSER_SEATS?.value) > 0;

  const renderNavItems = () => {
    return tabMenuItems?.map((item) => <SidebarMenuItem item={item} key={item?.url} />);
  };

  return (
    <Drawer show={shouldShowSidebarMenu} onHide={_hideSidebarMenu}>
      <Drawer.Header>
        <Drawer.Title className={styles.vpSidebarTitle}>{userName}</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <hr />
        {renderNavItems()}
        <hr />
        {!isAdminUser && (
          <section>
            <h4 className={styles.vpDrawerLink}>
              <NavLink
                to={APP_ROUTES.billing}
                data-testid="billingDrawerLink"
                activeClassName={styles.vpActiveLink}
              >
                Billing
              </NavLink>
            </h4>
            {isMultiuserEnabled && (
              <h4 className={styles.vpDrawerLink}>
                <NavLink to={APP_ROUTES.organization} activeClassName={styles.vpActiveLink}>
                  Users
                </NavLink>
              </h4>
            )}
            <h4 className={styles.vpDrawerLink}>
              <NavLink to={APP_ROUTES.settings} activeClassName={styles.vpActiveLink}>
                Settings
              </NavLink>
            </h4>
            <h4 className={styles.vpDrawerLink}>
              <NavLink to={APP_ROUTES.changePassword} className="item">
                Change Password
              </NavLink>
            </h4>
          </section>
        )}
        <hr />
        {!isAdminUser && (
          <section>
            <FeatureRenderer
              feature={FEATURES.upgrade_button}
              constraints={{
                [PLANS.enterprise.key]: true,
              }}
            >
              <h4 className={styles.vpDrawerLink}>
                <a
                  className=""
                  data-testid="upgradeDrawerLink"
                  onClick={() => {
                    handleUpgradeButtonClick(_push);
                  }}
                >
                  Upgrade
                </a>
              </h4>
            </FeatureRenderer>
            <h4 className={styles.vpDrawerLink}>
              <a
                className=""
                data-testid="feedbackDrawerLink"
                href="https://app.videopeel.com/c/ssthafdm"
                alt="Give us Feedback"
                target="_blank"
                rel="noreferrer"
              >
                Give us Feedback!
              </a>
            </h4>
            <hr />
            <OrganizationMenu />
            <h4 className={styles.vpDrawerLink}>
              <a href="" data-testid="logOutDrawerLink" onClick={_logOut}>
                Sign Out
              </a>
            </h4>
          </section>
        )}
      </Drawer.Body>
      <Drawer.Footer />
    </Drawer>
  );
};

SidebarMenu.propTypes = {
  _hideSidebarMenu: PropTypes.func,
  _logOut: PropTypes.func,
  _push: PropTypes.func,
  isSso: PropTypes.bool,
  shouldShowSidebarMenu: PropTypes.bool,
  userName: PropTypes.string,
  user: PropTypes.object,
  featurePermissions: PropTypes.shape({
    MULTIUSER_SEATS: PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  }),
};

function mapStateToProps(state) {
  return {
    user: state.get('auth').get('user'),
    shouldShowSidebarMenu: getIsSidebarMenuShowing(state),
    userName: getUserName(state),
    featurePermissions: getFeaturePermissions(state),
  };
}

const mapDispatchToProps = {
  _hideSidebarMenu: hideSidebarMenu,
  _logOut: logout,
  _push: push,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/Header/SidebarMenu.jsx